(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["diensten"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const dienstenSwiper = new Swiper('.diensten_section .swiper', {
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    spaceBetween: 16,
    slidesPerView: 'auto',
    centeredSlides: false,
    initialSlide: 0,
    breakpoints: {
      320: {
        slidesPerView: 1.2,
        spaceBetween: 8,
      },
      768: {
        slidesPerView: 2.2,
        spaceBetween: 12,
      },
      992: {
        slidesPerView: 3.2,
        spaceBetween: 16,
      },
      1200: {
        slidesPerView: 4.2,
        spaceBetween: 16,
      },
      1600: {
        slidesPerView: 5.2,
        spaceBetween: 16,
      }
    },
    navigation: {
      nextEl: '.diensten_section .swiper-button-next',
      prevEl: '.diensten_section .swiper-button-prev',
    },
  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const videoWrappers = document.querySelectorAll('.hero_video_item');
  
  videoWrappers.forEach(function(wrapper) {
    const video = wrapper.querySelector('.video');
    
    if (video) {
      // Pause video by default
      video.pause();
      
      // Play on hover
      wrapper.addEventListener('mouseenter', function() {
        video.play();
      });
      
      // Pause when hover ends
      wrapper.addEventListener('mouseleave', function() {
        video.pause();
      });
    }
    
    // Add click functionality if link is available
    const link = wrapper.getAttribute('data-link');
    if (link) {
      wrapper.addEventListener('click', function() {
        window.location.href = link;
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-feed"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
$('.i-6').slick({
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: '0',
        variableWidth: false,
        autoplay: true,        
        fade: false,
        arrows: true,
        dots: false,
        nextArrow: '<a class="next slick-next"><i class="fa fa-chevron-right"></i></a>',
        prevArrow: '<a class="prev slick-prev"><i class="fa fa-chevron-left"></i></a>',
        draggable: true,
        pauseOnHover: false,
        pauseOnFocus: false,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 2,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 768,
      settings: {
        centerMode: false,
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 650,
      settings: {
        centerMode: false,
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});
});

  } catch(e) { console.error(e); }
})();
})();
